/**
 * Can be used to define translations per-component
 *
 * @example
 * i18n: defineComponentTranslations({
 *   some_trl: {
 *     en: 'trl',
 *     el: 'τρλ'
 *   }
 * })
 *
 */
export function defineComponentTranslations(
  translations: Record<string, Record<'en' | 'el', string>>
) {
  const messages = Object.entries(translations).reduce(
    (
      acc: Record<'en' | 'el', Record<string, string>>,
      [translationKey, { en, el }]
    ) => {
      acc.en[translationKey] = en
      acc.el[translationKey] = el

      return acc
    },
    { en: {}, el: {} }
  )

  return { messages }
}
